import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
// Sonner Toaster (local wrapper)
import { Toaster as SonnerToaster } from './components/ui/sonner';

// Enable React strict mode in development
const StrictModeWrapper =
  process.env.NODE_ENV === 'development' ? React.StrictMode : React.Fragment;

ReactDOM.createRoot(document.getElementById('root')!).render(
  <StrictModeWrapper>
    <App />
    <SonnerToaster />
  </StrictModeWrapper>,
);
